const translations = {
	nature: "Nature",
	montant: "Montant",
	add: "Ajouter",
};

export default translations;
